module.exports = __webpack_public_path__ + "static/media/section-1.19be8cee.svg";